module.exports = __webpack_public_path__ + "media/images/amenities_icons/free_snack-59cabac98d5c373c0f2752545c7b4399.svg";